import React from "react";
import { Outlet, useLocation } from "react-router-dom";

const HEADERLESS_PATHS = new Set(["/auth/set-password"]);

export const AnonymousLayout: React.FC = () => {
  const { pathname } = useLocation();
  const showHeader = !HEADERLESS_PATHS.has(pathname.replace(/\/$/, ""));

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-50">
      <div className="max-w-md w-full rounded-2xl border border-slate-800 bg-slate-900/80 p-8 shadow-xl">
        {showHeader ? (
          <>
            <h1 className="text-xl font-semibold mb-2">Vision Ops 2</h1>
            <p className="text-sm text-slate-400 mb-6">
              Public layout for unauthenticated or error pages.
            </p>
          </>
        ) : null}
        <Outlet />
      </div>
    </div>
  );
};

export default AnonymousLayout;

